import cookies from 'js-cookie';
import CONFIG from '@config/';

export default cookies.withAttributes({ path: '/', domain: CONFIG.DOMAIN, secure: true });
